// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".divBox[data-v-1c148b49]  .el-card__header {\n  padding: 0 !important;\n}\n.divBox .el-pagination[data-v-1c148b49] {\n  padding: 0 !important;\n  margin: 0 !important;\n}\n.divBox .bottom[data-v-1c148b49] {\n  padding-top: 30px;\n}\n.search-btn[data-v-1c148b49] {\n  margin-left: 10px;\n}", ""]);
// Exports
module.exports = exports;
